// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file luwu/v1/cert.proto (package luwu.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file luwu/v1/cert.proto.
 */
export const file_luwu_v1_cert: GenFile = /*@__PURE__*/
  fileDesc("ChJsdXd1L3YxL2NlcnQucHJvdG8SB2x1d3UudjEigwEKClNoYXJlR3JhbnQSEAoIc2hhcmVfaWQYASABKAkSFgoOaG9zdF9kZXZpY2VfaWQYAiABKAkSEgoKc2Vzc2lvbl9pZBgDIAEoCRIRCgl3aW5kb3dfaWQYBCABKAkSEAoIY2FuX3R5cGUYBSABKAgSEgoKb3duZXJfbmFtZRgGIAEoCSKSAgoKRGV2aWNlQ2VydBIPCgd2ZXJzaW9uGAEgASgNEg4KBnNlcmlhbBgCIAEoCRIRCglkZXZpY2VfaWQYAyABKAkSDwoHcGVlcl9pZBgEIAEoCRISCgphY2NvdW50X2lkGAUgASgJEg8KB3RlYW1faWQYBiABKAkSIQoEcm9sZRgHIAEoDjITLmx1d3UudjEuRGV2aWNlUm9sZRIMCgRuYW1lGAggASgJEhAKCHBsYXRmb3JtGAkgASgJEgwKBGNhcHMYCiADKAkSEQoJaXNzdWVkX2F0GAsgASgDEhIKCmV4cGlyZXNfYXQYDCABKAMSIgoFZ3JhbnQYDSABKAsyEy5sdXd1LnYxLlNoYXJlR3JhbnQiMAoGU2lnbmVkEgwKBGJvZHkYASABKAwSCwoDa2lkGAIgASgJEgsKA3NpZxgDIAEoDCJhCgdSZXZva2VkEg4KBnNlcmlhbBgBIAEoCRIPCgdwZWVyX2lkGAIgASgJEhEKCWRldmljZV9pZBgDIAEoCRISCgpyZXZva2VkX2F0GAQgASgDEg4KBnJlYXNvbhgFIAEoCSJTCg5SZXZvY2F0aW9uTGlzdBILCgNzZXEYASABKAQSEQoJaXNzdWVkX2F0GAIgASgDEiEKB2VudHJpZXMYAyADKAsyEC5sdXd1LnYxLlJldm9rZWQiPAoFQ0FLZXkSCwoDa2lkGAEgASgJEhMKC2VkMjU1MTlfcHViGAIgASgMEhEKCW5vdF9hZnRlchgDIAEoAyIoCghDQUtleVNldBIcCgRrZXlzGAEgAygLMg4ubHV3dS52MS5DQUtleSpuCgpEZXZpY2VSb2xlEhsKF0RFVklDRV9ST0xFX1VOU1BFQ0lGSUVEEAASFAoQREVWSUNFX1JPTEVfSE9TVBABEhYKEkRFVklDRV9ST0xFX0NMSUVOVBACEhUKEURFVklDRV9ST0xFX0dVRVNUEANCKFombHV3dS5kZXYvZ28vaW50ZXJuYWwvcGIvbHV3dS92MTtsdXd1djFiBnByb3RvMw");

/**
 * ShareGrant is what a guest cert allows: one window on one computer, until
 * the cert expires. The host enforces it.
 *
 * @generated from message luwu.v1.ShareGrant
 */
export type ShareGrant = Message<"luwu.v1.ShareGrant"> & {
  /**
   * @generated from field: string share_id = 1;
   */
  shareId: string;

  /**
   * @generated from field: string host_device_id = 2;
   */
  hostDeviceId: string;

  /**
   * tmux session id ("$3")
   *
   * @generated from field: string session_id = 3;
   */
  sessionId: string;

  /**
   * tmux window id ("@7")
   *
   * @generated from field: string window_id = 4;
   */
  windowId: string;

  /**
   * @generated from field: bool can_type = 5;
   */
  canType: boolean;

  /**
   * shown to the guest
   *
   * @generated from field: string owner_name = 6;
   */
  ownerName: string;
};

/**
 * Describes the message luwu.v1.ShareGrant.
 * Use `create(ShareGrantSchema)` to create a new message.
 */
export const ShareGrantSchema: GenMessage<ShareGrant> = /*@__PURE__*/
  messageDesc(file_luwu_v1_cert, 0);

/**
 * @generated from message luwu.v1.DeviceCert
 */
export type DeviceCert = Message<"luwu.v1.DeviceCert"> & {
  /**
   * @generated from field: uint32 version = 1;
   */
  version: number;

  /**
   * @generated from field: string serial = 2;
   */
  serial: string;

  /**
   * @generated from field: string device_id = 3;
   */
  deviceId: string;

  /**
   * @generated from field: string peer_id = 4;
   */
  peerId: string;

  /**
   * @generated from field: string account_id = 5;
   */
  accountId: string;

  /**
   * @generated from field: string team_id = 6;
   */
  teamId: string;

  /**
   * @generated from field: luwu.v1.DeviceRole role = 7;
   */
  role: DeviceRole;

  /**
   * @generated from field: string name = 8;
   */
  name: string;

  /**
   * @generated from field: string platform = 9;
   */
  platform: string;

  /**
   * @generated from field: repeated string caps = 10;
   */
  caps: string[];

  /**
   * unix seconds
   *
   * @generated from field: int64 issued_at = 11;
   */
  issuedAt: bigint;

  /**
   * unix seconds
   *
   * @generated from field: int64 expires_at = 12;
   */
  expiresAt: bigint;

  /**
   * guests only
   *
   * @generated from field: luwu.v1.ShareGrant grant = 13;
   */
  grant?: ShareGrant | undefined;
};

/**
 * Describes the message luwu.v1.DeviceCert.
 * Use `create(DeviceCertSchema)` to create a new message.
 */
export const DeviceCertSchema: GenMessage<DeviceCert> = /*@__PURE__*/
  messageDesc(file_luwu_v1_cert, 1);

/**
 * Signed wraps a serialized body (DeviceCert, RevocationList, CAKeySet)
 * with an Ed25519 signature over a domain-separated prefix + body.
 *
 * @generated from message luwu.v1.Signed
 */
export type Signed = Message<"luwu.v1.Signed"> & {
  /**
   * @generated from field: bytes body = 1;
   */
  body: Uint8Array;

  /**
   * @generated from field: string kid = 2;
   */
  kid: string;

  /**
   * @generated from field: bytes sig = 3;
   */
  sig: Uint8Array;
};

/**
 * Describes the message luwu.v1.Signed.
 * Use `create(SignedSchema)` to create a new message.
 */
export const SignedSchema: GenMessage<Signed> = /*@__PURE__*/
  messageDesc(file_luwu_v1_cert, 2);

/**
 * @generated from message luwu.v1.Revoked
 */
export type Revoked = Message<"luwu.v1.Revoked"> & {
  /**
   * @generated from field: string serial = 1;
   */
  serial: string;

  /**
   * @generated from field: string peer_id = 2;
   */
  peerId: string;

  /**
   * @generated from field: string device_id = 3;
   */
  deviceId: string;

  /**
   * @generated from field: int64 revoked_at = 4;
   */
  revokedAt: bigint;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;
};

/**
 * Describes the message luwu.v1.Revoked.
 * Use `create(RevokedSchema)` to create a new message.
 */
export const RevokedSchema: GenMessage<Revoked> = /*@__PURE__*/
  messageDesc(file_luwu_v1_cert, 3);

/**
 * @generated from message luwu.v1.RevocationList
 */
export type RevocationList = Message<"luwu.v1.RevocationList"> & {
  /**
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;

  /**
   * @generated from field: int64 issued_at = 2;
   */
  issuedAt: bigint;

  /**
   * @generated from field: repeated luwu.v1.Revoked entries = 3;
   */
  entries: Revoked[];
};

/**
 * Describes the message luwu.v1.RevocationList.
 * Use `create(RevocationListSchema)` to create a new message.
 */
export const RevocationListSchema: GenMessage<RevocationList> = /*@__PURE__*/
  messageDesc(file_luwu_v1_cert, 4);

/**
 * @generated from message luwu.v1.CAKey
 */
export type CAKey = Message<"luwu.v1.CAKey"> & {
  /**
   * @generated from field: string kid = 1;
   */
  kid: string;

  /**
   * @generated from field: bytes ed25519_pub = 2;
   */
  ed25519Pub: Uint8Array;

  /**
   * @generated from field: int64 not_after = 3;
   */
  notAfter: bigint;
};

/**
 * Describes the message luwu.v1.CAKey.
 * Use `create(CAKeySchema)` to create a new message.
 */
export const CAKeySchema: GenMessage<CAKey> = /*@__PURE__*/
  messageDesc(file_luwu_v1_cert, 5);

/**
 * @generated from message luwu.v1.CAKeySet
 */
export type CAKeySet = Message<"luwu.v1.CAKeySet"> & {
  /**
   * @generated from field: repeated luwu.v1.CAKey keys = 1;
   */
  keys: CAKey[];
};

/**
 * Describes the message luwu.v1.CAKeySet.
 * Use `create(CAKeySetSchema)` to create a new message.
 */
export const CAKeySetSchema: GenMessage<CAKeySet> = /*@__PURE__*/
  messageDesc(file_luwu_v1_cert, 6);

/**
 * DeviceCert binds a libp2p PeerID to an account. It is issued by the
 * control plane CA and carried inside a Signed envelope.
 *
 * @generated from enum luwu.v1.DeviceRole
 */
export enum DeviceRole {
  /**
   * @generated from enum value: DEVICE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: DEVICE_ROLE_HOST = 1;
   */
  HOST = 1,

  /**
   * @generated from enum value: DEVICE_ROLE_CLIENT = 2;
   */
  CLIENT = 2,

  /**
   * A friend let into one shared window (ShareGrant); see docs/plan.md M6.5.
   *
   * @generated from enum value: DEVICE_ROLE_GUEST = 3;
   */
  GUEST = 3,
}

/**
 * Describes the enum luwu.v1.DeviceRole.
 */
export const DeviceRoleSchema: GenEnum<DeviceRole> = /*@__PURE__*/
  enumDesc(file_luwu_v1_cert, 0);

